import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-30616a68"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "no-more"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, "—— " + _toDisplayString($props.title || '没有更多了') + " ——", 1);
}